const utils = {
  getParameterByName(name, url) {
    let result = null
    if (!url) url = window.location.href
    name = name.replace(/[[\]]/g, '\\$&')
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    result = regex.exec(url)
    if (!result) return null
    if (!result[2]) return ''
    result = decodeURIComponent(result[2].replace(/\+/g, ' '))
    return result && result.length > 0 ? result : null
  },
  convertEspecialChar (value) {
    return value ? value.split('#$#').join("'") : null
  },
  getTranslation (value, locale) {
    if (!value) return 
    let aux = typeof value == 'object' ? value : JSON.parse(value)
    if (aux[locale]) return this.convertEspecialChar(aux[locale])
    else if (aux['en']) return this.convertEspecialChar(aux['en'])
    else {
      const firstKey = Object.keys(aux)[0]
      return this.convertEspecialChar(aux[firstKey])
    }
  },
}

export default utils

